import { atom } from "jotai";

type TextToSpeechPlayer = {
  isScrollingOverThreshold: boolean;
};

export const textToSpeechPlayerAtom = atom<TextToSpeechPlayer>({
  isScrollingOverThreshold: false,
});
